import React, { Component, Fragment } from "react";
import CheckAuth from "../../../utils/hoc/CheckAuth";
import Button from "../../../components/atoms/Button";
import DataTable from "../../organism/DataTable";
import ReactDOM from "react-dom";
import Loan from "../../../redux/actions/Loan";
import Loading from "../../../components/molecules/Loading";
import { connect } from "react-redux";
import curencyFormat from "../../../utils/helpers/curencyFormat";
import dateFormatIndo from "../../../utils/helpers/dateFormatIndo";
import formatNumber from "../../../utils/helpers/formatNumber";

let Selesai = [
	{ title: "Kode Pinjaman", data: "loanCode", width: "140" },
	{ title: "Jatuh Tempo", data: "loanDueDate", width: "100" },
	{ title: "Tanggal Pembayaran", data: "paymentDate", width: "100" },
	{ title: "Nilai Pinjaman", data: "loanAmount", width: "100" },
	{ title: "Status", data: "loanProgress", width: "50" },
	{ title: "Suku Bunga", data: "loanRate", width: "90" },
	{ title: "Tipe Pinjaman", data: "nameProductMapping", width: "100" },
	{ title: "", data: "loanCode", width: "100" },
];
let Gagal = [
	{ title: "Kode Pinjaman", data: "loanCode", width: "140" },
	{ title: "Nilai Pinjaman", data: "loanAmount", width: "100" },
	{ title: "Status", data: "loanProgress", width: "50" },
	{ title: "Suku Bunga", data: "loanRate", width: "90" },
	{ title: "Tipe Pinjaman", data: "loanTypeName", width: "100" },
	{ title: "", data: "loanCode", width: "100" },
];
let statusLoanDone = ["CC0", "CP1", "PD1"];
let statusLoanGagal = ["FL1", "NPL"];

class RiwayatPinjaman extends Component {
	constructor(props) {
		super(props);
		this.state = {
			statusBtn: [
				{ title: "Pinjaman Selesai", status: true, key: "PinjamanSelesai" },
				{ title: "Pinjaman Gagal", status: false, key: "PinjamanGagal" },
			],
			coloumnDefsSelesai: [
				{
					targets: [1, 2],
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>{cellData ? dateFormatIndo(cellData, "short") : "-"}</span>, td);
					},
				},
				{
					targets: 3,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>Rp {cellData ? curencyFormat(cellData) : "-"}</span>, td);
					},
				},
				{
					targets: 5,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>{cellData ? formatNumber(cellData, "", 2) : "-"}% p.a.</span>, td);
					},
				},
				{
					targets: Selesai.length - 1,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<Button title={"Lihat"} onClick={() => this.gotoDetail(cellData)} type={"button"} color="blue" width="small" />, td);
					},
				},
			],
			coloumnDefsGagal: [
				{
					targets: 1,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>Rp {cellData ? curencyFormat(cellData) : "-"}</span>, td);
					},
				},
				{
					targets: 3,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<span>{cellData ? formatNumber(cellData, "", 2) : "-"}% p.a.</span>, td);
					},
				},
				{
					targets: Gagal.length - 1,
					createdCell: (td, cellData, rowData, row, col) => {
						ReactDOM.render(<Button title={"Lihat"} onClick={() => this.gotoDetail(cellData)} type={"button"} color="blue" width="small" />, td);
					},
				},
			],
			idTable: "selesai",
			statusLoan: [...statusLoanDone, ...statusLoanGagal],
		};
	}
	changeBtn = (index) => {
		let { statusBtn } = this.state;
		this.changeList(statusBtn[index].key);
		for (let i = 0; i < statusBtn.length; i++) {
			if (i === index) {
				statusBtn[i].status = true;
			} else {
				statusBtn[i].status = false;
			}
		}
		this.setState({ statusBtn });
	};
	changeList = (key) => {
		let { idTable, data } = this.state;
		if (key === "PinjamanSelesai") {
			idTable = "selesai";
		} else if (key === "PinjamanGagal") {
			idTable = "gagal";
		}
		this.setState({ idTable });
	};
	componentDidMount = () => {
		this.props.setTitlePage({
			title: "Riwayat Pinjaman",
			breadcrumb: [
				{ name: "Beranda", url: "/dashboard", status: false },
				{ name: "Riwayat Pinjaman", url: "/#", status: true },
			],
		});
		if (this.props.ClientID !== null) {
			this.props.getListLoan(this.props.ClientID, this.state.statusLoan);
		}
	};
	gotoDetail = (loancode) => {
		this.props.history.push(`riwayat-pinjaman/detil/${loancode}`);
	};
	render() {
		let { data, coloumnDataTable, statusBtn, coloumnDefsAktif, coloumnDefsSelesai, coloumnDefsGagal, idTable } = this.state;
		const { list, loading } = this.props.loan;
		return (
			<div>
				<div className="row container-btn-menu">
					{statusBtn.map((value, index) => {
						return (
							<div className="container-menu" key={index}>
								{value.status ? (
									<Button title={value.title} type={"button"} color="yellow" width="small-rounded" onClick={() => this.changeBtn(index)} />
								) : (
									<Button title={value.title} type={"button"} color="yellow" width="small-rounded outline" onClick={() => this.changeBtn(index)} />
								)}
							</div>
						);
					})}
				</div>
				{loading ? (
					<Loading />
				) : (
					<Fragment>
						<DataTable
							isDisplay={idTable === "selesai" ? true : false}
							idTable={"selesai"}
							data={list != null ? list.filter((list) => statusLoanDone.includes(list.loanStatus)) : ""}
							coloumn={Selesai}
							coloumnDefs={coloumnDefsSelesai}
							fixedWidthColoumn={true}
						/>
						<DataTable
							isDisplay={idTable === "gagal" ? true : false}
							idTable={"gagal"}
							data={list != null ? list.filter((list) => statusLoanGagal.includes(list.loanStatus)) : ""}
							coloumn={Gagal}
							coloumnDefs={coloumnDefsGagal}
							fixedWidthColoumn={true}
						/>
					</Fragment>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		loan: state.loanState,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getListLoan: (ClientID, status) => {
			dispatch(Loan(ClientID, status));
		},
	};
};

export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(RiwayatPinjaman));
